export default Object.freeze({
  Request: 1,
  Other: 2,
  Memorandum: 3,
});
